export default __webpack_public_path__ + "static/media/AncientRuinsMap.f9394b19.jpg";